<template>
  <v-container class="feature text-center">
    <v-card class="icon" color="#b697ff">
      <i :class="icon" class="white--text fa-2x"></i>
    </v-card>
    <v-card class="card">
      <v-container class="pt-12" style="position: relative;">
        <p class="title pt-6">{{ title }}</p>
        <div class="divider"></div>
        <p class="body-1 pt-6 pb-12 grey--text text--darken-2">{{ body }}</p>
        <!-- <p class="caption" style="position:absolute; left:20px; bottom:10px;">Certified by <strong>{{cert}}</strong></p> -->
        <p
          v-if="cert"
          class="caption grey--text text--darken-2"
          style="position:absolute; left:20px; bottom:0px;"
        >
          Certified by
          <a :href="link" target="_blank" style="color: #b697ff;">{{ cert }}</a>
        </p>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Feature",
  props: {
    icon: String,
    title: String,
    body: String,
    cert: String,
    link: String
  }
};
</script>

<style lang="scss">
.feature {
  display: grid;
  width: 300px;
  min-height: 300px;

  .icon,
  .card {
    grid-column: 1;
    grid-row: 1;
  }
  .icon {
    z-index: 1;
    left: 88px;
    width: 100px;
    height: 100px;
    border-radius: 50px !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .card {
    margin-top: 50px;
    min-height: 250px;
    border-radius: 15px;

    .divider {
      height: 2px;
      margin-left: 76px;
      margin-right: 76px;
      width: 100px;
      background-color: #b697ff;
    }
  }
}
</style>
